import bulding from "../../img/building.jpg";
import bulb from "../../img/bulb.jpg";
import plant from "../../img/plant.jpg";
import { useEffect, useState } from "react";
import MovingText from "react-moving-text";

function BanerV2() {
  const [images] = useState([
    <Slider
      src={bulding}
      txt='Welcome to Krico'
      desc={
        "Empowering Tomorrow: Precision in Every Circuit, Excellence in Every Panel - Your Trusted Industrial Electrical Control Panel Manufacturer."
      }
      keyEle={0}
    />,
    <Slider
      src={bulb}
      txt='Best Industrial Electrical Control Panel Manufacturer & Suppliers in India '
      desc={
        "Elevate your power solutions with Krico Pannel – a beacon of innovation in electrical control panels. Precision engineering, reliability, and cutting-edge technology for a seamlessly connected and empowered future."
      }
      keyEle={1}
    />,
    <Slider
      src={plant}
      txt='Let us Em-power you'
      desc={
        "Pioneering excellence in electrical solutions, we specialize in manufacturing high voltage, medium voltage, and low voltage panels. Our commitment to quality and innovation ensures reliable, efficient power distribution for diverse applications."
      }
      keyEle={2}
    />,
  ]);
  let [src, setSrc] = useState(images[0]);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(async () => {
      i++;
      if (i === images.length) {
        i = 0;
      }

      setSrc(images[i]);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  return <div>{src}</div>;
}

const Slider = ({ src, txt, desc, keyEle }) => {
  return (
    <div key={keyEle}>
      <div className='w-full h-screen absolute top-0 left-0 z-0 bg-black'>
        <img
          id={"hero"}
          src={src}
          alt='banner'
          className='w-full h-screen object-cover opacity-50 z-10'
        />
        {/* <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1440 320'
          className='absolute -bottom-4 lg:-bottom-20 text-green-600'
        >
          <path
            style={{
              backgroundImage: `url(
          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 304 304' width='304' height='304'%3E%3Cpath fill='%23d23718' fill-opacity='0.4' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H224V21.9a5 5 0 1 1 2 0V82h-49.59L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E"
        )`,
            }}
            fill={"currentColor"}
            d='M0,96L40,80C80,64,160,32,240,42.7C320,53,400,107,480,144C560,181,640,203,720,197.3C800,192,880,160,960,144C1040,128,1120,128,1200,138.7C1280,149,1360,171,1400,181.3L1440,192L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z'
          ></path>
        </svg> */}
      </div>
      <div className='relative w-full xl:w-1/2 h-screen z-0 flex items-center justify-start px-4 sm:px-8 md:px-16 font-sans overflow-hidden'>
        <div className="flex flex-col space-y-6 max-w-full">
          <div className="overflow-hidden">
            <MovingText
              type='fadeInFromBottom'
              duration='1.2s'
              iteration='1'
              delay='0s'
              direction='normal'
              timing='cubic-bezier(0.16, 1, 0.3, 1)'
              fillMode='forwards'
            >
              <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-yellow-300 dark:text-yellow-200 font-extrabold leading-[1.1] tracking-tight'>
                <span className="block transform hover:scale-105 transition-transform duration-300">
                  {txt.split(' ').map((word, index) => (
                    <span 
                      key={index}
                      className="inline-block mr-[0.25em]"
                      style={{
                        animation: `slideUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${0.1 * index}s forwards`,
                        opacity: 0,
                        transform: 'translateY(100%)'
                      }}
                    >
                      {word}
                    </span>
                  ))}
                </span>
              </h1>
            </MovingText>
          </div>
          
          <div className="overflow-hidden">
            <MovingText
              type='fadeInFromBottom'
              duration='1.2s'
              iteration='1'
              delay='0.4s'
              direction='normal'
              timing='cubic-bezier(0.16, 1, 0.3, 1)'
              fillMode='forwards'
            >
              <p className='text-sm sm:text-base md:text-lg lg:text-xl text-gray-100/90 font-medium leading-relaxed tracking-wide max-w-prose'>
                <span className="block transform hover:scale-105 transition-transform duration-300">
                  {desc}
                </span>
              </p>
            </MovingText>
          </div>
        </div>

        <style jsx>{`
          @keyframes slideUp {
            0% {
              opacity: 0;
              transform: translateY(100%);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default BanerV2;
